import {Injectable} from '@angular/core';
import {UserAnswerMode, UserAnswerStateMode} from "../../model/user-answer.mode";
import {FIELD_TYPES} from "../../config/fieldTypes.config";

@Injectable({
  providedIn: 'root'
})
export class ChatQuestionsService {

  constructor() {

  }

  generateAnswer(q, value, editing?) {
    let answer: UserAnswerStateMode;

    if (q.fieldType === FIELD_TYPES.number) {
      value = value.replace(/\s/g, '');
    }

    if (q.fieldType === FIELD_TYPES.dollar) {
      value = value.replace(/[\s.,%]/g, '');
    }

    if (q.optionId && !q.isElementsGroup) {
      answer = {
        questionId: q.questionId,
        title: '',
        optionId: q.optionId,
        optionTitle: value,
      };
    } else if (q.fieldType === FIELD_TYPES.textList || q.fieldType === FIELD_TYPES.textListTwo) {
      answer = {
        questionId: q.questionId,
        title: '',
        answerListId: editing ? q.id : 0,
        answerListTitle: value,
      };
    } else if (q.fieldType === FIELD_TYPES.radio && (q.parentFieldType === FIELD_TYPES.textList || q.parentFieldType === FIELD_TYPES.textListTwo)) {
      if (value === 'add') {
        answer = {
          questionId: q.questionId,
          title: value,
          notSave: true
        };
      } else {
        answer = {
          questionId: q.questionId,
          title: 'done',
        };
      }

    } else if (q.isElementsGroup) {
      answer = {
        questionId: q.questionId,
        title: '',
        optionId: q.optionId,
        elementTitle: value,
      };

    } else {
      answer = {
        questionId: q.questionId,
        title: q.fieldType === FIELD_TYPES.dollar ? value.replace('$', '') : value,
      };
    }
    return answer;
  }

}
